import { useCallback, useEffect, useState } from "react";
import { CloseIcon, TemplateNotFound } from "../../components/icons/Icon2";
import Skeleton from "../../components/updatedComponents/Skeleton/Skeleton";
import { leadHistoryData } from "../../constants/constants";
import styles from "./Marketing2.module.css";
import fetchData from "../../APIsControll/apiControll";
import { formatDateTime, getStatusColor } from "../../Utils/Utils";
import NoDataFound from "../../components/updatedComponents/NoDataFound/NoDataFound";
import TextElement from "../../components/updatedComponents/FormComponents/TextElement";

const LeadHistoryModal = ({ mode, closeModal, managerId, lead }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const getLeadHistory = useCallback(async () => {
    const apiData = {
      managerId: managerId,
      leadId: lead.leadId,
    };
    try {
      setLoading(true);
      const res = await fetchData("leads/getHistory", apiData);
      if (res.status === "success") {
        setData(res.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }, [lead.leadId, managerId]);

  useEffect(() => {
    getLeadHistory();
  }, [getLeadHistory]);

  return (
    <div
      className={styles.lead_history_modal}
      style={{ backgroundColor: mode ? "#2C2E33" : "#F8F9FC" }}
    >
      <div className={styles.modal_header}>
        <p style={{ color: mode && "#FFFFFF" }}>Lead History</p>
        <div onClick={closeModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <div
        className={styles.text_con}
        style={{ borderColor: mode && "#646B88" }}
      >
        <div className={styles.text_con_head}>
          <TextElement
            label={"Name:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.name}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
          <TextElement
            label={"Lead ID:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.leadId}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
        </div>
        <div className={styles.text_con_head}>
          <TextElement
            label={"Mobile:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.mobile}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
          <p
            className={styles.status_text}
            style={{ color: getStatusColor(lead.status) }}
          >
            {lead.status}
          </p>
        </div>
        {lead.type === "wholesale" && (
          <TextElement
            label={"Company:"}
            labelColor={mode ? "#fff" : "#646B88"}
            value={lead.storeName}
            valueColor={mode ? "#fff" : "#646B88"}
            fontSize={"14px"}
            fontWeight={"600"}
          />
        )}
        <TextElement
          label={"Address:"}
          labelColor={mode ? "#fff" : "#646B88"}
          value={
            lead.pincode +
            " " +
            lead.city +
            " " +
            (lead.district || "") +
            " " +
            lead.state
          }
          valueColor={mode ? "#fff" : "#646B88"}
          fontSize={"14px"}
          fontWeight={"600"}
        />
        <TextElement
          label={"Assigned to:"}
          labelColor={mode ? "#fff" : "#646B88"}
          value={lead.assignedManager}
          valueColor={mode ? "#fff" : "#646B88"}
          fontSize={"14px"}
          fontWeight={"600"}
        />
      </div>

      {lead.status === "New" || lead.status === "Pending" ? (
        <div style={{ padding: "20px" }}>
          <NoDataFound icon={<TemplateNotFound />} textTitle={`No History!`} />
        </div>
      ) : (
        <ul className={styles.lead_table}>
          <li
            className={`${styles.lead_table_header} ${
              mode ? styles.lead_table_header_dark : ""
            }`}
          >
            {leadHistoryData?.map((h, index) => (
              <div className={styles.data_val} key={`${h}-${index}`}>
                {h}
              </div>
            ))}
          </li>

          <div className={styles.lead_table_list}>
            {data?.map((d, index) =>
              loading ? (
                <div>
                  <Skeleton
                    lines={data?.length === 1 ? 1 : data?.length / 2}
                    thickness={5}
                    additionalStyles={{
                      marginBottom: "0px",
                      marginTop: "0px",
                    }}
                  />
                </div>
              ) : (
                <li
                  className={`${styles.lead_table_row} ${
                    mode ? styles.lead_table_row_dark : ""
                  }`}
                  key={d.dealerId + index}
                >
                  <div className={styles.data_val}> {index + 1} </div>
                  <div className={styles.data_val} title={d.dealerName}>
                    {d.dealerName}
                  </div>
                  <div className={styles.data_val} title={d.storeName}>
                    {d.storeName}
                  </div>
                  <div
                    className={styles.data_val}
                    title={
                      d.pincode +
                      ", " +
                      d.street +
                      ", " +
                      d.city +
                      ", " +
                      d.state
                    }
                  >
                    {d.pincode +
                      ", " +
                      d.street +
                      ", " +
                      d.city +
                      ", " +
                      d.state}
                  </div>
                  <div
                    className={styles.data_val}
                    title={formatDateTime(d.firstShared)}
                  >
                    {formatDateTime(d.firstShared)}
                  </div>
                  <div
                    className={styles.data_val}
                    title={formatDateTime(d.lastShared)}
                  >
                    {formatDateTime(d.lastShared)}
                  </div>
                  <div className={styles.data_val} title={d.shareCount}>
                    {d.shareCount}
                  </div>
                </li>
              )
            )}
          </div>
        </ul>
      )}
    </div>
  );
};

export default LeadHistoryModal;
